var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M9.91671 1.41675H4.25004C3.47087 1.41675 2.83337 2.05425 2.83337 2.83341V14.1667C2.83337 14.9459 3.47087 15.5834 4.25004 15.5834H12.75C13.5292 15.5834 14.1667 14.9459 14.1667 14.1667V5.66675L9.91671 1.41675ZM12.75 14.1667H4.25004V2.83341H9.20837V6.37508H12.75V14.1667ZM6.37504 9.20842V13.4584H4.95837V9.20842H6.37504ZM10.625 10.6251V13.4584H12.0417V10.6251H10.625ZM7.79171 7.79175V13.4584H9.20837V7.79175H7.79171Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37504 9.20842V13.4584H4.95837V9.20842H6.37504ZM7.79171 7.79175V13.4584H9.20837V7.79175H7.79171Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarReports);
export default __webpack_public_path__ + "static/media/navbar-reports.f4fb6022.svg";
export { ForwardRef as ReactComponent };